<template>
    <v-container fluid>
        <c-dialog :dialog="dialogYn" :message="dialogMessage" :yes-text="yesText" @clickYes="dialogYn = false"></c-dialog>
        <div class="text-center">
            <!--
            <v-dialog v-model="dialogForTimer" width="500">
                <v-card color="#385F73" dark>
                    <v-card-text class="white--text">
                        <div class="headline mb-2">Timer</div>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn text @click="">Start</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            -->
            <v-dialog v-model="dialogForInol" width="500">
                <v-card>
                    <v-card-title class="subtitle-2">Single workout INOL of a single exercise</v-card-title>
                    <v-card-text>
                        <div class="text-left">
                            &lt; 0.4 : Super easy <br />
                            0.4 ~ 1 : Optimal in long run<br />
                            1 ~ 2 : Tough <br />
                            &gt; 2 : Brutal
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogForInol = false">
                            OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogForLogin" width="500">
                <v-card>
                    <v-card-text>
                        Sign-in is required.<br />
                        No Sign-up is required.<br />
                        You can sign-in with gmail, facebook.
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogForLogin = false">
                            OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogForSave" width="500">
                <v-card>
                    <v-card-text>
                        Save success.<br />
                        Are you want to clear?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogForSave = false">
                            NO
                        </v-btn>
                        <v-btn
                            text
                            @click="
                                dialogForSave = false;
                                clearRows();
                            "
                        >
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogForClear" width="500">
                <v-card>
                    <v-card-text>
                        Are you sure to clear?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogForClear = false">
                            No
                        </v-btn>
                        <v-btn text @click="clearRows"> Yes </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <v-container class="mb-n3 py-0" fluid>
            <v-row class="my-0 py-0">
                <v-col cols="8" class="py-0 my-0">
                    <v-combobox class="py-0 my-0" label="Exercise Name" prepend-inner-icon="mdi-dumbbell" outlined v-model="exerciseName" :items="listOfExerciseNames"></v-combobox>
                </v-col>
                <v-col cols="4" class="py-0">
                    <v-text-field class="py-0 my-0" type="number" label="1 RM" prepend-inner-icon="mdi-weight" outlined v-model.number="maxWeight"></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        <v-divider></v-divider>
        <div class="title mt-3">Set. {{ setNo }}</div>

        <v-container class="my-0 py-0" fluid>
            <v-row class="mt-0">
                <v-col cols="6">
                    <v-text-field type="number" label="Weight" outlined v-model.number="weight"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field type="number" label="Lifts" outlined v-model.number="lifts"></v-text-field>
                </v-col>
            </v-row>
            <div class="d-sm-none mx-0 px-0">
                <v-row class="mt-n10 mx-0 px-0">
                    <v-col cols="6" class="mx-0 px-0">
                        <v-container class="mt-n5">
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyWeight(20)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                20
                                <v-btn icon @click="modifyWeight(-20)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyWeight(10)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                10
                                <v-btn icon @click="modifyWeight(-10)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyWeight(5)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                5
                                <v-btn icon @click="modifyWeight(-5)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyWeight(1)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                1
                                <v-btn icon @click="modifyWeight(-1)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col cols="6" class="mx-0 px-0">
                        <v-container class="mt-n5">
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyLifts(10)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                10
                                <v-btn icon @click="modifyLifts(-10)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyLifts(5)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                5
                                <v-btn icon @click="modifyLifts(-5)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyLifts(2)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                2
                                <v-btn icon @click="modifyLifts(-2)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                            <v-row class="d-flex align-center justify-space-between">
                                <v-btn icon @click="modifyLifts(1)"><v-icon>mdi-arrow-up-bold-circle</v-icon></v-btn>
                                1
                                <v-btn icon @click="modifyLifts(-1)"><v-icon>mdi-arrow-down-bold-circle</v-icon></v-btn>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </div>
            <v-row class="d-flex align-center justify-center mt-n5">
                <v-btn @click="setDone"> Set {{ setNo }} Done</v-btn>
            </v-row>
        </v-container>
        <v-divider class="mt-3"></v-divider>
        <div class="title mt-3">Records</div>
        <v-layout justify-center class="mt-2">
            <v-flex text-center xs12>
                <v-simple-table style="table-layout: fixed;">
                    <thead>
                        <tr>
                            <th class="text-left" style="width:10%">Set No.</th>
                            <th class="text-left" style="width:30%">Weight</th>
                            <th class="text-left" style="width:30%">Lifts</th>
                            <th class="text-left" style="width:30%">INOL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in rows" :key="item.set">
                            <td class="text-left" style="width:10%">{{ item.set }}</td>
                            <td class="text-left" style="width:30%"><input type="number" style="width:100%" v-model.number="item['weight']" placeholder="Weight" /></td>

                            <td class="text-left" style="width:30%"><input type="number" style="width:100%" v-model.number="item['lifts']" placeholder="Lifts" /></td>

                            <td class="text-left" style="width:30%">{{ item['inol'] }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-flex>
        </v-layout>
        <v-footer app class="d-flex align-center justify-space-between">
            <div class="white--text title">Total INOL: {{ totalInol }}</div>
            <v-btn text @click="dialogForInol = true" v-if="level" class="mx-0 px-0"> {{ level }}<v-icon right>mdi-help-circle</v-icon> </v-btn>
        </v-footer>
        <!--
        <v-btn color="blue" dark small absolute bottom right fab>
            <v-icon>mdi-timer</v-icon>
        </v-btn>
        -->
    </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import moment from 'moment';
import global from './../global.js';
import Dialog from './Dialog.vue';

const updateInol = function() {
    this.rows.forEach(item => {
        let inol = Number.parseFloat(item.lifts / (100 - (item.weight / this.maxWeight) * 100)).toFixed(2);
        if (item.weight >= this.maxWeight && item.lifts > 0) {
            inol = 4;
        }
        item.inol = isNaN(inol) ? 0.0 : inol;
    });
    this.totalInol = Number.parseFloat(this.rows.reduce((sum, val) => Number(sum) + Number(val.inol), 0)).toFixed(2);
    if (this.totalInol > 0) {
        if (this.totalInol <= 0.4) {
            this.level = 'Super Easy';
        } else if (this.totalInol <= 1) {
            this.level = 'Optimal';
        } else if (this.totalInol <= 2) {
            this.level = 'Tough';
        } else if (this.totalInol > 2) {
            this.level = 'Crazy';
        }
    } else {
        this.level = null;
    }
    // this.ripple(this.$refs.totalInolRipple.$el);
};
export default {
    name: 'calculator',
    data: () => ({
        dialogForTimer: true,
        dialogForInol: false,
        dialogYn: false,
        dialogMessage: null,
        noText: null,
        yesText: null,
        dialogForLogin: false,
        dialogForSave: false,
        dialogForClear: false,
        exerciseName: null,
        listOfExercise: [],
        listOfExerciseNames: [],
        rows: [],
        totalInol: 0.0,
        maxWeight: 0,
        user: null,
        level: null,
        weight: 0,
        lifts: 0,
        setNo: 1,
    }),
    methods: {
        setDone: function() {
            if (this.maxWeight <= 0) {
                this.alert('Set 1 RM weight first', 'OK');
                return;
            }
            if (this.weight > 0 && this.lifts > 0) {
                this.addRow();
                this.rows[0].weight = this.weight;
                this.rows[0].lifts = this.lifts;
                updateInol.call(this);
                this.setNo++;
            } else {
                this.alert('Done nothing', 'OK');
            }
        },
        modifyWeight: function(change) {
            this.weight += change;
            if (this.weight < 0) {
                this.weight = 0;
            }
        },
        modifyLifts: function(change) {
            this.lifts += change;
            if (this.lifts < 0) {
                this.lifts = 0;
            }
        },
        addRow: function() {
            this.rows.splice(0, 0, {
                set: this.rows.length + 1,
                weight: 0,
                lifts: 0,
                inol: 0.0,
            });
        },
        clearRows: function() {
            this.rows = [];
            this.dialogForClear = false;
            this.totalInol = 0.0;
            this.weight = 0;
            this.lifts = 0;
            this.setNo = 1;
        },
        alert(message, yesText) {
            this.dialogYn = true;
            this.dialogMessage = message;
            this.yesText = yesText;
        },
        save: function() {
            if (!this.exerciseName) {
                this.alert('Set exercise name first.', 'OK');
            } else if (this.user) {
                const db = firebase.firestore();
                const today = moment().format('YYYYMMDD');
                const totalInol = Number.parseFloat(this.totalInol);
                db.collection('user')
                    .doc(this.user.uid)
                    .collection('exercise')
                    .doc(this.exerciseName)
                    .set({
                        maxWeight: this.maxWeight,
                        lastDate: today,
                        lastInol: totalInol,
                    })
                    .then(() => {
                        this.getExerciseList();
                    });
                if (totalInol > 0) {
                    let rows = this.rows.filter(item => item.weight && item.lifts);
                    let log = {
                        set: rows.filter(item => item.weight && item.lifts).length,
                        lifts: rows.reduce((sum, item) => sum + item.lifts, 0),
                        inol: totalInol,
                        date: today,
                        exercise: this.exerciseName,
                        detail: rows,
                    };

                    let exerciseLog = {};
                    exerciseLog[this.exerciseName] = log;
                    db.collection('dayLogs')
                        .doc(this.user.uid)
                        .collection('day')
                        .doc(today)
                        .update(exerciseLog)
                        .catch(err => {
                            if (err.code === 'not-found') {
                                db.collection('dayLogs')
                                    .doc(this.user.uid)
                                    .collection('day')
                                    .doc(today)
                                    .set(exerciseLog);
                            }
                        });

                    db.collection('exerciseLogs')
                        .doc(this.user.uid)
                        .collection('exercise')
                        .doc(this.exerciseName)
                        .collection('day')
                        .doc(today)
                        .set(log);
                }
                this.dialogForSave = true;
            } else {
                this.dialogForLogin = true;
            }
        },
        getExerciseList() {
            firebase
                .firestore()
                .collection('user')
                .doc(this.user.uid)
                .collection('exercise')
                .get()
                .then(result => {
                    this.listOfExercise.length = 0;
                    result.forEach(doc => {
                        this.listOfExercise.push({
                            name: doc.id,
                            maxWeight: doc.data().maxWeight,
                            lastDate: doc.data().lastDate,
                            lastInol: doc.data().lastInol,
                        });
                    });

                    this.listOfExerciseNames = this.listOfExercise.map(item => item.name);
                });
        },
        ripple: function($el) {
            let ev = new Event('mousedown');
            let offset = $el.getBoundingClientRect();
            ev.clientX = offset.left + offset.width / 2;
            ev.clientY = offset.top + offset.height / 2;
            $el.dispatchEvent(ev);

            setTimeout(function() {
                $el.dispatchEvent(new Event('mouseup'));
            }, 300);
        },
    },
    watch: {
        exerciseName: function(val) {
            if (this.maxWeight > 0 && this.totalInol > 0) {
                return;
            }
            if (typeof val !== 'string') {
                val = val.text;
            }
            let item = this.listOfExercise.find(item => item.name === val);
            if (item) {
                this.maxWeight = item.maxWeight;
            }
        },
        rows: {
            handler: function() {
                updateInol.call(this);
            },
            deep: true,
        },
        maxWeight: function() {
            updateInol.call(this);
        },
    },
    beforeCreate() {
        /**
         * 새로고침 하거나, 브라우저를 껐다가 켜도 세션에서 사용자 정보를 읽어오기 때문에
         * beforeCreate에서 onAuthStateChanged를 등록해준다.
         */
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.user = user;
                this.getExerciseList();
            } else {
                this.user = null;
            }
        });
    },
    created() {
        global.bus.$on('calculatorSave', this.save);
        global.bus.$on('calculatorClear', () => {
            this.dialogForClear = true;
        });
    },
    components: {
        'c-dialog': Dialog,
    },
};
</script>

<style scoped></style>
